import { roles } from "../../../../helpers/utils/Constants/roles";

export const filterArray = [
  {
    id: 1,
    name: "Business Analyst",
    value: "business_analyst",
  },

  {
    id: 2,
    name: "Product Owner",
    value: "product_owner",
  },

  {
    id: 3,
    name: "Scrum Master",
    value: "scrum_master",
  },
  // {
  //   id: 9,
  //   name: "Self Paced Agile Project Manager",
  //   value: roles.SELF_PACED_AGILE_PROJECT_MANAGER_STUDENT,
  // },
  // {
  //   id: 16,
  //   name: "Self Paced Product Manager (Landing)",
  //   value: roles.SELF_PACED_PRODUCT_MANAGER_LANDING,
  // },
  // {
  //   id: 17,
  //   name: "Self Paced Product Owner (Landing)",
  //   value: roles.SELF_PACED_PRODUCT_OWNER_LANDING,
  // },
  // {
  //   id: 18,
  //   name: "Self Paced Business Analyst (Landing)",
  //   value: roles.SELF_PACED_BUSINESS_ANALYST_LANDING,
  // },
  // {
  //   id: 19,
  //   name: "Self Paced Scrum Master (Landing)",
  //   value: roles.SELF_PACED_SCRUM_MASTER_LANDING,
  // },
  {
    id: 10,
    name: "AI Business Analyst",
    value: roles.AI_BUSINESS_ANALYST_STUDENT,
  },
  {
    id: 4,
    name: "AA-PDM",
    value: "aa_product_manager",
  },
  {
    id: 5,
    name: "Landing Page",
    value: "landing_page",
  },
  {
    id: 6,
    name: "TAC-ICP",
    value: "icp",
  },
  {
    id: 7,
    name: "TAC-ICP-APO",
    value: "apo",
  },
  {
    id: 8,
    name: "TAC-PDM",
    value: "product_manager",
  },
  {
    id: 11,
    name: "Product Owner",
    value: "landing_page_po",
  },
  {
    id: 12,
    name: "Business Analyst",
    value: "landing_page_ba",
  },
  {
    id: 13,
    name: "Product Manager",
    value: "landing_page_pm",
  },
  {
    id: 14,
    name: "Tech Sales SDR",
    value: "landing_page_sdr",
  },
  {
    id: 15,
    name: "Cybersecurity",
    value: "landing_page_ca",
  },
  {
    id: 16,
    name: "Agile Fundamental (ICP) Certification",
    value: "icp_certification",
  },
  {
    id: 17,
    name: "ICP - PDM Certification",
    value: "icp_pdm_certification",
  },
];

export const SelfFilterArray = [
  {
    id: 9,
    name: "Self Paced Agile Project Manager",
    value: roles.SELF_PACED_AGILE_PROJECT_MANAGER_STUDENT,
  },
  {
    id: 16,
    name: "Self Paced Product Manager (Landing)",
    value: roles.SELF_PACED_PRODUCT_MANAGER_LANDING,
  },
  {
    id: 17,
    name: "Self Paced Product Owner (Landing)",
    value: roles.SELF_PACED_PRODUCT_OWNER_LANDING,
  },
  {
    id: 18,
    name: "Self Paced Business Analyst (Landing)",
    value: roles.SELF_PACED_BUSINESS_ANALYST_LANDING,
  },
  {
    id: 19,
    name: "Self Paced Scrum Master (Landing)",
    value: roles.SELF_PACED_SCRUM_MASTER_LANDING,
  },
];

export const filterArrayForTAC = [
  {
    id: 2,
    name: "ICP",
    value: "icp",
  },
  {
    id: 5,
    name: "ICP-APO",
    value: "apo",
  },
  {
    id: 1,
    name: "PDM",
    value: "product_manager",
  },
  {
    id: 6,
    name: "APM",
    value: "agile_project_management",
  },
  {
    id: 4,
    name: "ICP-ACC",
    value: "icp_acc",
  },
  {
    id: 3,
    name: "ATF",
    value: "agile_team_facilitator",
  },
  {
    id: 7,
    name: "SELF-APM",
    value: "self_apm",
  },
  {
    id: 8,
    name: "SELF-PACED-PDM",
    value: "spp",
  },
  {
    id: 9,
    name: "FAI",
    value: "fai",
  },
];
